import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "custom-select flex-row gap-20 align-items-end justify-content-start" }
const _hoisted_3 = { class: "custom-select links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, [
  /*#__PURE__*/_createTextVNode(" Employer(s) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " *")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "text-secondary-red"
}
const _hoisted_6 = { class: "custom-select links" }
const _hoisted_7 = { class: "body-text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "Complete the information below and hit the 'Submit' button in the lower right hand corner.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        id: "missing-contribution-form",
        class: "form missing-contribution align-items-end gap-20",
        method: "post",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DateInput, {
            label: "Work Period",
            modelValue: $setup.filters.WorkPeriod.StartDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.WorkPeriod.StartDate) = $event)),
            "is-required": true,
            error: $setup.errors['WorkPeriod.StartDate']
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_DateInput, {
            label: "",
            modelValue: $setup.filters.WorkPeriod.EndDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.WorkPeriod.EndDate) = $event)),
            error: $setup.errors['WorkPeriod.EndDate']
          }, null, 8, ["modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Multiselect, {
            modelValue: $setup.filters.Employers,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.Employers) = $event)),
            options: $setup.employers,
            placeholder: "Type to search",
            multiple: true,
            "hide-selected": true,
            searchable: true,
            "close-on-select": true,
            onSelect: $setup.handleEmployerChange,
            label: "Name",
            "track-by": "ID",
            onSearchChange: $setup.handleEmployersSearch,
            onRemove: $setup.handleProductions,
            loading: $setup.loadingEmployers
          }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "onRemove", "loading"]),
          ($setup.errors.Employers?.length)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString($setup.errors.Employers.join('. ')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createTextVNode(" Production(s) "),
            ($setup.hasEmployers)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " for selected Employer(s)"))
              : _createCommentVNode("", true),
            _createTextVNode(": ")
          ]),
          _createVNode(_component_Multiselect, {
            modelValue: $setup.filters.Productions,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.Productions) = $event)),
            options: $setup.productions,
            placeholder: "Type to search",
            multiple: true,
            "hide-selected": true,
            searchable: true,
            "close-on-select": true,
            onSelect: $setup.handleProductionChange,
            label: "Name",
            "track-by": "ID",
            onOpen: $setup.handleProductionsOpen,
            onSearchChange: $setup.handleProductionsSearch,
            loading: $setup.loadingProductions
          }, null, 8, ["modelValue", "options", "onSelect", "onOpen", "onSearchChange", "loading"])
        ]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "number",
          label: "Member Name or SSN",
          placeholder: "Enter Member Name or SSN",
          max: 12,
          modelValue: $setup.filters.ParticipantID,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.ParticipantID) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Textarea, {
          label: "Additional Info:",
          palceholder: "Type here...",
          modelValue: $setup.filters.Additional,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters.Additional) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary ms-auto mt-10",
          disabled: $setup.loadingSubmit,
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
        }, _toDisplayString($setup.loadingSubmit ? 'Submitting...' : 'Submit'), 9, _hoisted_9)
      ], 32)
    ])
  ], 64))
}